<template>
  <div class="root container">
    <VueConfirmDialog :parent="_uid" />
    <section>
      <h3 class="push-down-30 header">Packing Lists</h3>
      <router-link :to="{ name: 'PackingListTemplateCreate' }">
        <button class="btn btn-default push-down-30 add-list-btn">Add A New List
          <i class="material-symbols-outlined cancel pointer">add</i>
        </button>
      </router-link>
      <div class="row">
        <div
          class="col-12 col-sm-6 list-wrapper push-down-20"
          :key="index"
          v-for="(item, index) in list"
        >
          <RuxCard
            :images="item.images"
            :rux="item"
            showDelete="true"
            @handleDelete="deleteItem(index)"
            :clickTarget="{
              name: 'PackingListTemplateItem',
              params: { name: item.shortDescription },
            }"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import RuxCard from './../RuxCard'
import VueConfirmDialog from './../ConfirmDialog/vue-confirm-dialog.vue'
export default {
  name: 'PackingListTemplateList',
  components: { RuxCard, VueConfirmDialog },
  computed: {
    ...mapState({
      list: (state) =>
        state.packingListTemplate.list.map((template) => {
          return {
            ...template,
            shortDescription: template.name,
            images: template.images.slice(0,2)
          }
        }),
    }),
  },
  mounted() {
    this.$store.dispatch('packingListTemplate/getAllPackingListTemplates')
  },
  methods: {
    deleteItem: function (index) {
      // Show a confirm dialog so people don't delete stuff with fat thumbs
      this.$confirm({
        message:
          'Really delete this template? It will no longer be publicly visible if you have shared it.',
        buttons: [
          {
            text: 'Cancel',
          },
          {
            text: 'Delete',
            callback: () => {
              const item = this.list[index]
              //Emit the delete event with the index and item
              this.$store.dispatch('packingListTemplate/delete', {
                item,
              })
            },
          },
        ],
        parent: this._uid,
      })
    },
  },
}
</script>

<style lang='scss' scoped>

.header {
  text-align: left;
  font-family: "Neue Roman";
  margin-top: 40px;
}
.material-symbols-outlined {
  color: white;
  padding-bottom: 3px;
}
.add-list-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  background-color: $ruxGreen;
}
.add-list-btn:focus {
  box-shadow: none;
  outline: 0.5px black solid;
}

a {
  text-decoration: none;
}
</style>